import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {getTableScrollbar} from '../../../util/scrollbar';
import React from 'react';
import {useTranslation} from 'react-i18next';


const useStyles = makeStyles((theme) => ({
    container: {
        position: "absolute",
        width: "calc(100% - 10px)",
        height: "100%",
        background: theme.palette.background.defaultBackground,
        zIndex: 1
    },
    content: {
        height: "100%"
    },
}));

function FullScreenForm (props) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    return <div className={classes.container}>
        <div className={clsx(classes.content, getTableScrollbar())}>
            {props.children}
        </div>

    </div>
}

export default FullScreenForm;